// src/components/AuthForm.jsx
import React, { useState } from 'react';

const AuthForm = ({ trackingNumber, authType, onSubmit, onBack, loading }) => {
  const [authValue, setAuthValue] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Formulario enviado:', {
      trackingNumber: trackingNumber,
      authValue: authValue,
    });

    if (authValue.trim() && trackingNumber) {
      onSubmit(authValue.trim());
    } else {
      console.error('Faltan datos:', { trackingNumber, authValue });
    }
  };

  const getAuthLabel = () => {
    return authType === 'zipcode' ? 'Código Postal' : 'RFC';
  };

  const getPlaceholder = () => {
    return authType === 'zipcode' ? 'Ej: 00000' : 'Ej: XAXX010101000';
  };

  const getDescription = () => {
    return authType === 'zipcode'
      ? 'Ingresa el código postal de la dirección de entrega'
      : 'Ingresa el RFC de la empresa que realizó el pedido';
  };

  return (
    <div className="w-full max-w-md mx-auto bg-white/10 backdrop-blur-lg rounded-2xl p-6 md:p-8 border-2 border-white/20">
      <div className="text-center mb-6">
        <div className="w-12 h-12 bg-packsys-orange rounded-full flex items-center justify-center mx-auto mb-4">
          <svg
            className="w-6 h-6 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
            />
          </svg>
        </div>
        <h3 className="text-white text-xl font-bold mb-2">
          Verificación Requerida
        </h3>
        <p className="text-gray-200 text-sm mb-2">{getDescription()}</p>
        <p className="text-gray-300 text-xs">
          Número de tracking: <strong>{trackingNumber}</strong>
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-white text-sm font-medium mb-2">
            {getAuthLabel()}
          </label>
          <input
            type="text"
            value={authValue}
            onChange={(e) => setAuthValue(e.target.value)}
            className="w-full bg-white/95 text-slate-800 border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-packsys-orange focus:border-transparent"
            placeholder={getPlaceholder()}
            disabled={loading}
          />
        </div>

        <div className="flex space-x-3">
          <button
            type="button"
            onClick={onBack}
            disabled={loading}
            className="flex-1 bg-gray-500 text-white py-3 px-4 rounded-xl font-medium hover:bg-gray-600 transition-all duration-300 disabled:opacity-50"
          >
            Volver
          </button>
          <button
            type="submit"
            disabled={loading || !authValue.trim() || !trackingNumber}
            className="flex-1 bg-packsys-orange text-white py-3 px-4 rounded-xl font-medium hover:bg-orange-600 transition-all duration-300 disabled:opacity-50"
          >
            {loading ? 'Verificando...' : 'Continuar'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AuthForm;
